import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import SurveyContainer from "components/NPSSurvey/SurveyContainer";
import { setParentId } from "src/pods/parentStudents";
import { showNativeNav } from "src/pods/webviewInit";

function Index() {
  const [params] = useSearchParams();
  const { parentId } = Object.fromEntries(params.entries());

  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.beyond"]);

  const dispatch = useDispatch();

  const [innerHeight, setInnerHeight] = useState<number | string>("100vh");

  // bulk ignore existing useEffects
  // eslint-disable-next-line @web-monorepo/no-useEffect
  useEffect(() => {
    showNativeNav(true);
    return () => {
      showNativeNav(false);
    };
  }, []);

  // bulk ignore existing useEffects
  // eslint-disable-next-line @web-monorepo/no-useEffect
  useEffect(() => {
    setInnerHeight(window.innerHeight);
  }, []);

  // bulk ignore existing useEffects
  // eslint-disable-next-line @web-monorepo/no-useEffect
  useEffect(() => {
    if (parentId) {
      dispatch(setParentId(parentId));
    }
  }, [dispatch, parentId]);

  if (!ready) return null;

  return <SurveyContainer innerHeight={innerHeight} />;
}

export default Index;
